import LocaleManager from '../utils/LocaleManager.js';
import Config from '../utils/Config.js';
import Utils from '../utils/Utils.js';
import StateButton from '../controls/StateButton.js';

export default class Footer extends Phaser.Group {

    constructor(game, { balance, bet })
    {
        super(game);

        this.params = { balance, bet };

        const bg = new Phaser.Image(game, 0, 0, 'panels.footer-bg');
        bg.width = Config.GAME_WIDTH;
        this.addChild(bg);

        const font = { fontSize: 14, fill: '#FAFAFA', font: Config.DEFAULT_FONT, fontWeight: 'bold' };

        const padding = Config.layout === Config.PORTRAIT ? 10: 20;
        const balanceWnd = new Phaser.Image(game, 7, 0, 'panels.footer-money-bg');
        balanceWnd.position.set(
            padding,
            bg.height - balanceWnd.height >> 1
        );
        this.addChild(balanceWnd);
        balanceWnd.addChild(new Phaser.Text(this.game, 11, 5, LocaleManager.getString('balance'), font));
        this.textBalance = balanceWnd.addChild(new Phaser.Text(this.game, balanceWnd.width - 11, 5, Utils.formatMoney(this.params.balance), font));
        this.textBalance.anchor.x = 1;
        
        const betWnd = new Phaser.Image(game, 0, 0, 'panels.footer-money-bg');
        betWnd.position.set(bg.width - betWnd.width - padding, (bg.height - betWnd.height) >> 1);
        this.addChild(betWnd);         
        betWnd.addChild(new Phaser.Text( this.game, 11, 5, LocaleManager.getString('bet').toLocaleUpperCase(), font));
        this.textBet = betWnd.addChild(new Phaser.Text(this.game, betWnd.width - 11, 5, '', font));
        this.textBet.anchor.x = 1;
        this.updateBet(this.params.bet);

        const logo = new Phaser.Image(game, 0, 0, 'footer.logo');
        const effectiveFooterHeight = bg.height - 4;
        const logoScale = logo.height > effectiveFooterHeight ? Math.min(effectiveFooterHeight / logo.height) : 1;
        logo.scale.set(logoScale);
        logo.position.set(
            bg.width - logo.width >> 1,
            (bg.height - logo.height >> 1)
        );
        this.addChild(logo);
    }

    createBalanceFrame()
    {
        const font = this.font;
        const frameID = 'footer/balance_frame';
        const betWnd = new Phaser.Image(game, 0,0, Utils.resolveKey(game, frameID));
        this.addChild(betWnd);
        betWnd.addChild(new Phaser.Text(this.game, 11, 5, LocaleManager.getString('bet').toLocaleUpperCase(), font));
        this.textBet = betWnd.addChild(new Phaser.Text(this.game, betWnd.width - 11, 5, '0', font));
        this.textBet.anchor.x = 1;
    }

    updateBalance(value = 0)
    {
        this.textBalance.text = Utils.formatMoney(value);
    }

    updateBet(value = 0)
    {
        this.textBet.text = Utils.formatMoney(value * Config.NUMBER_OF_LINES);
    }
}